import { useEffect, useState } from "react";
import "./autosuggest.scss";
import { AutoComplete, AutoCompleteCompleteEvent } from "primereact/autocomplete";
import { postData } from "../../services/global.service";
import { SEARCH_API_CONSTANTS } from "../../constants/search.constanst";
import { APIEnv, APIStatus } from "../../interface/baseInterfaces";
import useDebounce from "../../useDebounce";

const Autosuggest = ({ value, type, onGetAutoSuggestValue }: any) => {
  const [items, setItems] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>('');

  const searchBody = {
    "searchType": type,
    "searchText": searchQuery
  };

  const search = (event: AutoCompleteCompleteEvent) => {
    let query = event.query;
      setSearchQuery(query)
  }

  useDebounce(
    () => {
      if (searchQuery.trim()?.length >= 3) {
        getItems();
      }
    },
    [searchQuery, type], 
    400 
  );


  function getItems() {
    postData(SEARCH_API_CONSTANTS.SEARCH_SUGGESTIONS,
      searchBody,
      APIEnv.NODE_PREMIUM).then((response => {
        if (response?.ResponseType == APIStatus.SUCCESS) {
          setItems(response.data.date.itemarray);
        }
      }
      )
      ).catch(err => {
      })
  }

 const setAutoSuggestValue = (value:string) => {
  onGetAutoSuggestValue(value) 
}

  return (
    <AutoComplete field="name" value={value} suggestions={items} completeMethod={search} onChange={(e) => { setAutoSuggestValue(e.value) }}   />
  );
};

export default Autosuggest;
